module.exports = __webpack_public_path__ + "img/winter_cookie.fbb4bf57.png";